import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import ReactModal from 'react-modal'

class Modal extends Component {
  render () {
    const classNames = [
      css.modal,
      this.props.center ? css.center : '',
      this.props.short ? css.short : '',
      this.props.mini ? css.mini : '',
      this.props.modalWidth ? css[this.props.modalWidth] : css.widthDefault
    ]
    return (
      <ReactModal
        isOpen={this.props.isOpen}
        onRequestClose={this.props.onRequestClose}
        overlayClassName={css.overlay}
        contentLabel={'Modal'}
        className={classNames.join(' ')}>
        <button className={css.close} onClick={this.props.onRequestClose}>×</button>
        <div>
          {this.props.children}
        </div>
      </ReactModal>
    )
  }
}

Modal.propTypes = {
  modalWidth: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  center: PropTypes.bool,
  short: PropTypes.bool
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/modal/index.js